import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AlarmLog } from '../../../../class/Alarm';
import { AlarmEditService } from '../../../../services/alarm-edit.service';
import { AlarmsListService } from '../../../../services/alarms-list.service';
import { DevicesManagerService } from '../../../../services/devices-manager.service';

import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import DynamicDatePipe from '../../../../utils/pipes/dynamic-date.pipe';

@Component({
  selector: 'alarm-log-card',
  templateUrl: './alarm-log-card.component.html',
  styleUrls: ['./alarm-log-card.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTooltipModule, DynamicDatePipe, TranslatePipe],
})
export class AlarmLogCardComponent {
  public alarmLog = input.required<AlarmLog>();
  public isDisplayAlarmName = input<boolean>();
  private _devicesManagerService = inject(DevicesManagerService);
  private _alarmEditService = inject(AlarmEditService);
  private _alarmsListService = inject(AlarmsListService);
  public $alarmsById = this._alarmsListService.$alarmsById;

  public $device = computed(() => this._devicesManagerService.get(this.alarmLog().uid_device));

  public acquitLog() {
    this._alarmEditService.acquitLog(this.alarmLog().uid, []);
  }
}
